import { Component} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
    selector: 'app-referafriend',
    templateUrl: './referafriend.component.html',
    styleUrls: ['./referafriend.component.css'],
    standalone: false
})
export class ReferafriendComponent { 
  constructor(public dialog: NgbModal) {}
}